import axios from "axios";
import moment from "moment";

const INVESTIGATIONS_BASE = process.env.REACT_APP_SERVICES_URL + "/vi";
const DATE_FORMAT = "M/DD/YYYY";

class InvestigationsApi {
  searchInvestigations = (
    recipientFirstName,
    recipientLastName,
    recipientEmail,
    recipientPhone,
    requesterFirstName,
    requesterLastName,
    orgId,
    useDateRange,
    dateRangeFilter
  ) => {
    const url = INVESTIGATIONS_BASE + "/investigation";

    let start = moment(dateRangeFilter.start);
    let end = moment(dateRangeFilter.end);
    const params = {
      recipientFirstName,
      recipientLastName,
      recipientEmail,
      recipientPhone,
      requesterFirstName,
      requesterLastName,
      orgId,
      startDate: start.format(DATE_FORMAT),
      endDate: end.format(DATE_FORMAT),
      dateFormat: DATE_FORMAT,
      dateRangeFilter
    };
    return axios.post(url, params).then(response => {
      if (response.data.alerts) {
        // this endpoint returns 207 Multi-Status
        // since errors are inside the payload
        // the top level alerts signifies to list out the errors for each override
        response.data.entity.forEach(o => {
          if (o.httpStatus === 500) {
            console.error(o.message);
          }
        });
      }
      return response.data.entity;
    });
  };

  sendReport = params => {
    const url = INVESTIGATIONS_BASE + "/investigation/report";
    // blob is needed tell the browser to convert to the file type provided by the response
    return axios.post(url, params, { responseType: "blob" }).then(response => {
      if (response.data.alerts) {
        // this endpoint returns 207 Multi-Status
        // since errors are inside the payload
        // the top level alerts signifies to list out the errors for each override
        response.data.entity.forEach(o => {
          if (o.httpStatus === 500) {
            console.error(o.message);
          }
        });
      }
      return response;
    });
  };
}

export default InvestigationsApi;
